









































import { Component, Vue } from "vue-property-decorator";
import datos_adicionales_productoModule from "@/store/modules/datos_adicionales_producto-module";
import { ProcessoNums, getTexto } from "../procesos/ProcessoNums";
import productoModule from "@/store/modules/producto-module";
import DataTable from "@/components/DataTableGenerico/DataTable.vue";
import { ClassColumnDataTable } from "@/components/DataTableGenerico/ClassColumnDataTable";
import { datatypes } from "@/components/DataTableGenerico/datatypes";
import { datos_adicionales_producto } from "@/shared/dtos/datos_adicionales_producto";

import { DxColumn, DxButton } from "devextreme-vue/data-grid";
import { producto } from "@/shared/dtos/producto";
import { RouterNames } from "@/router/routernames";
import ProcesoVenta from "../procesos/proceso_venta.vue";
import ocultarcamposModule from "@/store/modules/ocultarcampos-module";
@Component({
  components: {
    DataTable,
    DxColumn,
    DxButton,
    ProcesoVenta,
  },
})
export default class PendienteDePago extends Vue {
  datos_adiciones: datos_adicionales_producto[] = [];
  public proceso_venta_show = false;
  public selectedRow: producto = new producto();
  async created() {
    await datos_adicionales_productoModule.getdatos_adicionales_productos();
    await productoModule.getproductos();
    this.datos_adiciones =
      datos_adicionales_productoModule.datos_adicionales_productos;
    this.datos_adiciones = this.datos_adiciones.filter(
      (x) => x.tipo_registro === ProcessoNums.PendientePago
    );
  }

  calculatePrecioVenta(rowData: any) {
    // Calcula el 50% del valor de la columna total_retail
    return (
      Math.round(
        (rowData.total_retail ? rowData.total_retail * 0.5 : 0) * 100
      ) /
        100 +
      " €"
    );
  }

  amazonLinkTemplate(container: any, options: any) {
    if (options.value) {
      const link = document.createElement("a");
      link.href = options.value; // Valor del campo link_amazon
      link.textContent = "Amazon"; // Texto visible
      link.target = "_blank"; // Abre en una nueva pestaña
      link.rel = "noopener noreferrer"; // Seguridad adicional
      link.style.color = "black"; // Define el color negro para el texto del enlace
      link.style.textDecoration = "none"; // Opcional: elimina el subrayado
      container.appendChild(link);
    } else {
      container.textContent = "No disponible"; // Texto por defecto si el enlace está vacío
    }
  }

  proceso_vender(e: any) {
    var rowSelected = e.row.key;
    e.event.preventDefault();
    if (confirm("¿Quieres vender el producto?")) {
      // Aquí puedes ejecutar la lógica de venta
      console.log(e, e.row.data.id);
      this.selectedRow = new producto(e.row.data);
      this.proceso_venta_show = true;
    }
  }

  get data_source() {
    var productos_reservados = productoModule.productos.filter(
      (producto: any) => {
        const adicion = this.datos_adiciones.find(
          (adicion) => adicion.id_prodcuto === producto.id
        );

        if (adicion) {
          // Asignar el valor de 'adicion.text' al producto
          producto.text = adicion.texto;
          return true;
        }
        return false;
      }
    );
    return productos_reservados;
  }

  abrir_producto(e: any) {
    var rowSelected = e.row.key;
    e.event.preventDefault();
    this.$router.push({
      name: RouterNames.fichaproducto,
      params: { id: new producto(e.row.data).id },
    });
  }
  get mostrarCamposCoste() {
    return ocultarcamposModule.mostrar_campos_coste;
  }
  get Columns() {
    var Columnas: ClassColumnDataTable[] = [];

    // Agregar columnas a la tabla
    Columnas.push(
      new ClassColumnDataTable(
        "pkg_id",
        "ID de Paquete",
        datatypes.string,
        true,
        datatypes.maxlength
      )
    );
    Columnas.push(
      new ClassColumnDataTable(
        "item_desc",
        "Descripción del Producto",
        datatypes.string,
        true,
        datatypes.maxlength
      )
    );
    Columnas.push(
      new ClassColumnDataTable(
        "item_pkg_weight",
        "Peso del Paquete",
        datatypes.number,
        true,
        datatypes.maxlength
      )
    );
    Columnas.push(
      new ClassColumnDataTable(
        "total_retail",
        "Total Venta",
        datatypes.number,
        true,
        datatypes.maxlength
      )
    );
    Columnas.push(
      new ClassColumnDataTable(
        "lpn",
        "LPN",
        datatypes.string,
        true,
        datatypes.maxlength
      )
    );
    Columnas.push(
      new ClassColumnDataTable(
        "coste_compra",
        "Costo de Compra",
        datatypes.number,
        this.mostrarCamposCoste,
        datatypes.maxlength
      )
    );
    Columnas.push(
      new ClassColumnDataTable(
        "precio_vendido",
        "Precio Vendido",
        datatypes.number,
        true,
        datatypes.maxlength
      )
    );
    Columnas.push(
      new ClassColumnDataTable(
        "text",
        "Pendiente por",
        datatypes.string,
        true,
        datatypes.maxlength
      )
    );
    return Columnas;
  }
}
